import React, { useState } from "react";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { message } from "antd";
import TextStyles from "../../../../../../Constants/TextStyles";
import Styled from "../../PageOne/PageOne";
import { useDispatch, useSelector } from "react-redux";
import { updatePrivacyDataPC } from "../../../../../../store/service/proposalAndContractService";
import Colors from "../../../../../../Constants/Colors";
import ModalUpdateDataPrivacy from "../../PageModals/ModalUpdateDataPrivacy";

const PrivacyData = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const selectedData = useSelector(
    (state) => state.proposalAndContract.selectedData
  );
  const dispatch = useDispatch();

  const defaultHeading = "Data Privacy and Security";

  const defaultParagraph = `A. Definitions:\n\n1. "Borrower Data" means all information, including Personal Data, related to the Client ("Borrower").\n\n2. "Client Data" refers to Personal Data, Employment Data, and other information provided by or processed for the Client by the Contractor or third parties on behalf of the Client.\n\n3. "Data Protection Laws" encompasses data privacy and protection laws, including the European Community Data Protection Directive and other applicable laws.\n\n4. "Notices" includes filings, communications, press releases, or reports related to any Security Breach.\n\n5. "Personal Data" covers any information related to an identified or identifiable natural person, including names, addresses, Social Security numbers, financial information, and health-related data.\n\n6. "Processing" refers to any operation performed on Client Data, such as collection, storage, or disclosure.\n\n7. "Security Breach" indicates any unauthorized access, use, or loss of Client Data compromising its security, confidentiality, or integrity.\n\nB. Data Processing:\n\nContractor will process Client Data only as required for the Project's services or as instructed by the Client in writing. For Employment Data, Contractor will adhere to Client policy or an agreed-upon policy.\n\nC. Data Security:\n\nContractor shall provide Client with data security system information upon request. Contractor will comply with the Client's applicable data security policies and implement measures to ensure data security, confidentiality, and prevention of unauthorized access.\n\nD. European Community:\n\nIf Personal Data is transferred outside the European Community, both parties will comply with applicable Data Protection Laws, including executing data transfer agreements or notifying local Data Protection Authorities.\n\nE. Agreement with Third Parties:\n\nContractor will ensure that any third parties involved in providing services maintain adequate data security measures consistent with Contractor's obligations.\n\nF. Security Breach Notification and Costs:\n\nContractor will promptly notify Client of any Security Breach involving Client Data and take necessary actions to investigate, prevent, and mitigate the impact. Contractor will provide relevant information for Client's compliance with applicable laws and reimburse Client for costs incurred due to a Security Breach. Any voluntary actions will be equitably allocated between the parties.`;

const heading =
  selectedData && selectedData.privacy_data && selectedData.privacy_data.heading
    ? selectedData.privacy_data.heading
    : defaultHeading;  

  const paragraph =
    selectedData &&
    selectedData.privacy_data &&
    selectedData.privacy_data.paragraph
      ? selectedData.privacy_data.paragraph
      : "";

  const isDataPrivacyRequired =
    selectedData &&
    selectedData.privacy_data &&
    selectedData.privacy_data.required
      ? true
      : false;

  const togglePrivacyViewHandler = () => {
    const Obj = {
      _id: selectedData._id,
      privacy_data: {
        required: !isDataPrivacyRequired,
        heading,
        paragraph,
      },
    };
    dispatch(updatePrivacyDataPC(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        message.success(
          isDataPrivacyRequired
            ? "Clause hidden successfully!"
            : "Clause unhidden successfully!"
        );
      } else {
        message.error(`${data.error.message}!`);
      }
    });
  };

  return (
    <div>
      <Styled.ReviewContentBox className="mt-4">
        <div className="edit-delete-icons">
          <span onClick={togglePrivacyViewHandler}>
            {isDataPrivacyRequired ? (
              <VisibilityOffOutlinedIcon
                sx={{
                  cursor: "pointer",
                  color: Colors.font2,
                  opacity: 0.8,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              />
            ) : (
              <VisibilityOutlinedIcon
                sx={{
                  cursor: "pointer",
                  color: Colors.font2,
                  opacity: 0.8,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              />
            )}
          </span>

          {isDataPrivacyRequired && (
            <BorderColorOutlinedIcon
              sx={{
                cursor: "pointer",
                color: Colors.font2,
                opacity: 0.8,
                marginLeft: 2,
                "&:hover": {
                  opacity: 1,
                },
              }}
              onClick={() => setShowPrivacyModal(true)}
            />
          )}
        </div>

        <TextStyles.FontSize20px className="mb-3 overflow-hidden">
          <span
            className={`fw-medium ${isDataPrivacyRequired ? "" : "disabled"}`}
          >
            {heading}
          </span>
        </TextStyles.FontSize20px>

        <TextStyles.FontSize14px
          className={`lh-lg overflow-hidden ${isDataPrivacyRequired ? "" : "disabled"}`}
          style={{ whiteSpace: "break-spaces" }}
        >
          {paragraph ? (
            paragraph
          ) : (
            <>
              <div>
                <TextStyles.FontSize16px className="fw-medium">
                  A. Definitions:
                </TextStyles.FontSize16px>
                <div className="mt-2">
                  <div className="mt-2 ms-3">
                    1. "Borrower Data" means all information, including Personal
                    Data, related to the Client ("Borrower").
                  </div>
                  <div className="mt-2 ms-3">
                    2. "Client Data" refers to Personal Data, Employment Data,
                    and other information provided by or processed for the
                    Client by the Contractor or third parties on behalf of the
                    Client.
                  </div>
                  <div className="mt-2 ms-3">
                    3. "Data Protection Laws" encompasses data privacy and
                    protection laws, including the European Community Data
                    Protection Directive and other applicable laws.
                  </div>
                  <div className="mt-2 ms-3">
                    4. "Notices" includes filings, communications, press
                    releases, or reports related to any Security Breach.
                  </div>
                  <div className="mt-2 ms-3">
                    5. "Personal Data" covers any information related to an
                    identified or identifiable natural person, including names,
                    addresses, Social Security numbers, financial information,
                    and health-related data.
                  </div>
                  <div className="mt-2 ms-3">
                    6. "Processing" refers to any operation performed on Client
                    Data, such as collection, storage, or disclosure.
                  </div>
                  <div className="mt-2 ms-3">
                    7. "Security Breach" indicates any unauthorized access, use,
                    or loss of Client Data compromising its security,
                    confidentiality, or integrity.
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <TextStyles.FontSize16px className="fw-medium">
                  B. Data Processing:
                </TextStyles.FontSize16px>
                <TextStyles.FontSize14px className="mt-2">
                  Contractor will process Client Data only as required for the
                  Project's services or as instructed by the Client in writing.
                  For Employment Data, Contractor will adhere to Client policy
                  or an agreed-upon policy.
                </TextStyles.FontSize14px>
              </div>
              <div className="mt-3">
                <TextStyles.FontSize16px className="fw-medium">
                  C. Data Security:
                </TextStyles.FontSize16px>
                <TextStyles.FontSize14px className="mt-2">
                  Contractor shall provide Client with data security system
                  information upon request. Contractor will comply with the
                  Client's applicable data security policies and implement
                  measures to ensure data security, confidentiality, and
                  prevention of unauthorized access.
                </TextStyles.FontSize14px>
              </div>
              <div className="mt-3">
                <TextStyles.FontSize16px className="fw-medium">
                  D. European Community:
                </TextStyles.FontSize16px>
                <TextStyles.FontSize14px className="mt-2">
                  If Personal Data is transferred outside the European
                  Community, both parties will comply with applicable Data
                  Protection Laws, including executing data transfer agreements
                  or notifying local Data Protection Authorities.
                </TextStyles.FontSize14px>
              </div>
              <div className="mt-3">
                <TextStyles.FontSize16px className="fw-medium">
                  E. Agreement with Third Parties:
                </TextStyles.FontSize16px>
                <TextStyles.FontSize14px className="mt-2">
                  Contractor will ensure that any third parties involved in
                  providing services maintain adequate data security measures
                  consistent with Contractor's obligations.
                </TextStyles.FontSize14px>
              </div>
              <div className="mt-3">
                <TextStyles.FontSize16px className="fw-medium">
                  F. Security Breach Notification and Costs:
                </TextStyles.FontSize16px>
                <TextStyles.FontSize14px className="mt-2">
                  Contractor will promptly notify Client of any Security Breach
                  involving Client Data and take necessary actions to
                  investigate, prevent, and mitigate the impact. Contractor will
                  provide relevant information for Client's compliance with
                  applicable laws and reimburse Client for costs incurred due to
                  a Security Breach. Any voluntary actions will be equitably
                  allocated between the parties.
                </TextStyles.FontSize14px>
              </div>
            </>
          )}
        </TextStyles.FontSize14px>
      </Styled.ReviewContentBox>

      {showPrivacyModal && (
        <ModalUpdateDataPrivacy
          show={showPrivacyModal}
          handleClose={() => setShowPrivacyModal(false)}
          heading={heading}
          paragraph={paragraph}
          defaultHeading={defaultHeading}
          defaultParagraph={defaultParagraph}
        />
      )}
    </div>
  );
};

export default PrivacyData;
